import ButtonActionsOnUser from '../buttonActionsOnUser';
import { AdminUserPermissionsEnum } from '@/lib/enum';
import { SecuredComponent } from '@/components/hoc';
import BannerUserInfos from '../bannerUserInfos';
import { IUserData } from '@/lib/interface.ts';
import { Separator } from '@/components/ui';
import { TButtonVariant } from '@/types';

interface TProps {
	user: IUserData;
	disableActionInvalidations?: boolean;
	removeItemLocally?: (userId: string) => void;
	buttonActionOnUserProps?: {
		variant?: TButtonVariant;
	}
}

const PhotoVerificationGroupHeader = ({ user, buttonActionOnUserProps, disableActionInvalidations, removeItemLocally }: TProps) => (
	<div className='flex flex-col'>
		<div className='flex items-end justify-between'>
			<BannerUserInfos
				hideEmail
				enableClickToRedirectToProfile
				className='py-2 px-3 w-full'
				user={user} />
			<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.PROFILE_DETAIL_ACTIONS]}>
				<ButtonActionsOnUser
					hideText
					disableInvalidateQueries={disableActionInvalidations}
					removeItemLocally={removeItemLocally}
					variant={buttonActionOnUserProps?.variant}
					className='mx-3 my-3'
					user={user} />
			</SecuredComponent>
		</div>
		<Separator />
	</div>
);

export default PhotoVerificationGroupHeader;
